import { Municipio } from "app/models/fichaRegistro.model"
import { Tipologia, TipologiasInterface } from "app/models/tipologias.model"

export class AddColeccionistaModel {
  nombre: string
  cui: string
  nit: string
  correoElectronico: string
  tipoRepresentacion: TipoRepresentacion
  titular: Titular
  departamento: Departamento
  municipio: TipologiasInterface
  coleccion: Coleccion
  seccion:TipologiasInterface
  telefono:number
}

export interface TipoRepresentacion {
  tipologiaId: number
  tipologiaPadreId: number
  descripcion: string
  valor1: string
  valor2: string
  valor3: string
  tipologias: any
}

export interface Titular {
  tipologiaId: number
  tipologiaPadreId: number
  descripcion: string
  valor1: string
  valor2: string
  valor3: string
  tipologias: any
}

export interface Departamento {
  tipologiaId: number
  tipologiaPadreId: number
  descripcion: string
  valor1: string
  valor2: string
  valor3: string
  tipologias: any
}

export interface Coleccion {
  tipologiaId: number
  tipologiaPadreId: number
  descripcion: string
  valor1: string
  valor2: string
  valor3: string
  tipologias: any
}
